module.exports = __webpack_public_path__ + "img/KU_SubLogo.eef9e6c6.png";